import { ReportFeatures } from '@hcs/types';

export const SUBJECT_IMAGE_SECTION_FEATURES = [
  ReportFeatures.SubjectPhotosCurrent,
  ReportFeatures.SubjectPhotosAll,
  ReportFeatures.SubjectStreetview,
];
